<ng-container *ngIf="isFormLoaded && !saveSuccess">
  <header class="layout-topbar no-nav">
    <a *ngIf="form.cdnLogoUrldn" class="logo" routerLink="">
      <img [src]="form.cdnLogoUrldn" />
    </a>

    <h1 class="app-title">{{ form?.title }}</h1>
  </header>
  <ng-container *ngIf="!this.isFormView && !isInternal && isFormExpOrInactive">
    <span
      >The form you requested is not available for submission at this
      time.</span
    >
  </ng-container>
  <ng-container *ngIf="isInternal || !isFormExpOrInactive">
    <div class="container" style="padding-top: 20px">
      <div class="p-grid">
        <div class="p-col">
          <h3 *ngIf="form.instructions" style="margin-bottom: 10px">
            Form Instructions
          </h3>
          <p>{{ form?.instructions }}</p>
        </div>
      </div>

      <p-card>
        <div
          *ngIf="isInternal"
          class="p-col-12"
          role="region"
          aria-label="Internal Form Details"
        >
          <span><label>Link to Form</label>{{ formUrl }}</span>
        </div>

        <div class="p-grid">
          <div class="p-col text-right">
            <div
              class="required-note"
              role="region"
              aria-label="Form Instructions"
            >
              <p class="required">Required field</p>
              <p>
                Save button will enable when all required fields are complete.
              </p>
            </div>
          </div>
        </div>
        <div class="p-grid p-fluid p-dir-col">
          <div *ngFor="let section of form?.sections; let inc = index">
            <div class="p-col" role="region" aria-label="Form Section Header">
              <h2>
                Section
                <span *ngIf="form?.sections.length > 1">{{ inc + 1 }}</span>
              </h2>
            </div>
            <div class="p-col" role="region" aria-label="Section Title">
              <h3>{{ section.title }}</h3>
              <p *ngIf="section.instructions">
                <strong>Section Instructions:</strong>
                {{ section.instructions }}.
              </p>
              <div
                *ngFor="
                  let question of section?.questions;
                  let rowIndex = index
                "
              >
                <div class="p-col">
                  <label [attr.for]="question.id">
                    <span *ngIf="question.required"
                      ><span class="required"></span></span
                    ><span class="q-number">{{ rowIndex + 1 }}.</span
                    >{{ question.question.question }}</label
                  >
                  <div style="padding-top: 0px">
                    <textarea
                      [id]="question.id"
                      rows="5"
                      cols="30"
                      *ngIf="question.question.type === 'TEXTAREA'"
                      [(ngModel)]="question.question.selAnswer"
                      pInputTextarea
                      [appCharCount]="question.question.maxAnswerLength"
                      location="below"
                      align="right"
                    ></textarea>
                    <p-radioButton
                      [(ngModel)]="question.question.selAnswer"
                      *ngIf="question.question.type === 'BOOL'"
                      name="YES"
                      value="Yes"
                      label="Yes"
                    ></p-radioButton>
                    <p-radioButton
                      [(ngModel)]="question.question.selAnswer"
                      *ngIf="question.question.type === 'BOOL'"
                      name="NO"
                      value="No"
                      label="No"
                    ></p-radioButton>
                    <p-dropdown
                      *ngIf="question.question.type === 'SELECT'"
                      [(ngModel)]="question.question.selAnswer"
                      [options]="list"
                      (onClick)="getOptionList(question.question)"
                    >
                    </p-dropdown>
                    <p-calendar
                      *ngIf="question.question.type === 'DATE'"
                      [monthNavigator]="true"
                      [yearNavigator]="true"
                      [yearRange]="getYearRange(question)"
                      [readonlyInput]="canEnterDateManually(question)"
                      [showIcon]="true"
                      showButtonBar="true"
                      dateFormat="mm/dd/yy"
                      [(ngModel)]="question.question.selAnswer"
                      [minDate]="question.question.minDate"
                      [maxDate]="question.question.maxDate"
                      clearButtonStyleclass="p-button-rounded p-button-outlined p-button-secondary"
                      appendTo="body"
                    ></p-calendar>
                    <div
                      *ngFor="
                        let answers of question?.question.answers;
                        let rowIndex = index
                      "
                    >
                      <div
                        class="p-col"
                        *ngIf="question.question.type == 'CHECKBOX'"
                      >
                        <p-checkbox
                          aria-label="Answer"
                          name="group1"
                          [(ngModel)]="question.question.selAnswer"
                          name="radio1"
                          [value]="answers.id"
                          label="{{ answers.answer }}"
                        ></p-checkbox>
                      </div>
                      <div
                        class="p-col"
                        *ngIf="question.question.type === 'RADIO'"
                      >
                        <p-radioButton
                          aria-label="Answer"
                          [(ngModel)]="question.question.selAnswer"
                          name="radio1"
                          [value]="answers.id"
                          [label]="answers.answer"
                        ></p-radioButton>
                      </div>
                    </div>
                    <input
                      *ngIf="question.question.type === 'TEXT'"
                      [(ngModel)]="question.question.selAnswer"
                      type="text"
                      aria-label="Answer"
                      pInputText
                    />
                    <p-dropdown
                      *ngIf="question.question.type === 'ALTER_EMAIL'"
                      aria-label="Answer"
                      [(ngModel)]="question.question.selAnswer"
                      [options]="list"
                      (onClick)="getOptionList(question.question)"
                    >
                    </p-dropdown>
                  </div>
                  <p></p>
                  <ng-container *ngIf="question?.question?.files?.length > 0">
                    <div class="p-grid p-fluid">
                      <div class="p-col">Question Image</div>
                      <!-- <div class="p-col-fixed" style="width:100px">
                        Delete
                      </div> -->
                    </div>
                    <div class="p-grid p-fluid">
                      <div class="p-col">
                        <img [src]="getImage(question.question)" />
                      </div>
                      <!-- <div class="p-col-fixed" style="width:100px">
                        <button pButton icon="pi pi-trash"
                          class="p-button-rounded p-button-secondary p-button-text action-icon" type="button"
                          pTooltip="Delete" [disabled]="true" tooltipPosition="bottom"></button>
                      </div> -->
                    </div>
                  </ng-container>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          *ngIf="isInternal"
          class="p-col-12"
          role="region"
          aria-label="Internal Form Details"
        >
          <span><label>Link to Form</label>{{ formUrl }}</span>
        </div>
        <div
          *ngIf="form.displaySendCopyToSubmitter === 'Yes'"
          class="p-text-left"
          style="margin-bottom: 20px"
        >
          <label for="optionalEmails"
            >OPTIONAL Please enter your email address if you wish to receive a
            copy of the form data that you are submitting:<input
              id="optionalEmails"
              type="text"
              style="width: 300px"
              maxlength="100"
              pInputText
          /></label>
        </div>
        <div
          *ngIf="form.displayRequireValidation === 'Yes'"
          class="p-text-center"
          style="display: flex; justify-content: center; margin-bottom: 20px"
        >
          <img
            *ngIf="this.isFormView"
            size="50%"
            disabled="true"
            src="assets/images/invisible_badge.png"
            alt="hCaptcha"
          />
          <div #hcaptchaWrapper *ngIf="!this.isFormView">
            <ng-hcaptcha
              *ngIf="!this.isFormView"
              name="captcha"
              required
              (verify)="hcaptcha($event)"
            >
            </ng-hcaptcha>
          </div>
        </div>
        <div class="p-text-center" role="region" aria-label="Buttons">
          <button
            *ngIf="form.destinationType === 'DB'"
            pButton
            type="button"
            [disabled]="!isOneFieldEntered()"
            label="Save for Later"
            class="p-button-rounded p-mr-2"
            (click)="saveForLaterModal = true"
          ></button>
          <button
            pButton
            type="button"
            [disabled]="!isFormValid()"
            label="Submit"
            (click)="confirmSubmit()"
            class="p-button-rounded p-button-secondary p-mr-2"
          ></button>
          <button
            pButton
            type="button"
            [disabled]="!isOneFieldEntered()"
            (click)="clear()"
            label="Clear"
            class="p-button-rounded p-button-outlined p-button-secondary"
          ></button>
        </div>
      </p-card>
    </div>
  </ng-container>
</ng-container>

<p-confirmDialog
  [style]="{ width: '500px' }"
  [baseZIndex]="10000"
></p-confirmDialog>

<ng-container *ngIf="saveSuccess">
  <br />
  <div>
    <h2>Thank you. Your information has been submitted.</h2>
    <div style="font-size: 1.2em; font-weight: bold">
      <span *ngIf="form.postSubmissionLabel">
        {{ form.postSubmissionLabel }}
      </span>
      <span *ngIf="form.postSubmissionLink" style="padding-left: 40px">
        <span
          ><a href="{{ form.postSubmissionLink }}">{{
            form.postSubmissionLink
          }}</a></span
        >
      </span>
    </div>
  </div>
</ng-container>
<!--------------------------- Save for Later ------------------------->
<p-dialog
  header="Save for Later"
  [(visible)]="saveForLaterModal"
  [modal]="true"
  [responsive]="true"
  [style]="{ width: '600px', minWidth: '300px' }"
  [maximizable]="false"
  [resizable]="true"
>
  <div class="p-grid p-fluid">
    <div class="p-col">
      <p class="large">
        Please provide an email address where you can receive the instructions
        for returning to the form.
      </p>

      <label for="emailAddressForReturn">Email</label>
      <input
        id="emailAddressForReturn"
        type="email"
        [(ngModel)]="emailAddress"
        pInputText
        style="margin-bottom: 10px"
        maxlength="80"
        email
      />
    </div>
  </div>

  <p-footer>
    <button
      type="button"
      [disabled]="!isValidateEmail()"
      pButton
      label="Save"
      (click)="saveForLater()"
      class="p-button-rounded p-button-secondary"
    ></button>
    <button
      type="button"
      pButton
      (click)="saveForLaterModal = false"
      label="Cancel"
      class="p-button-rounded p-button-outlined p-button-secondary"
    ></button>
  </p-footer>
</p-dialog>
<!--------------------------- End Save for Later ------------------------->

<!--------------------------- Saved Form ------------------------->
<p-dialog
  header="Save for Later"
  [(visible)]="savedFormEmailModal"
  [modal]="true"
  [responsive]="true"
  [style]="{ width: '600px', minWidth: '300px' }"
  [maximizable]="false"
  [resizable]="true"
>
  <div class="p-grid p-fluid">
    <div class="p-col">
      <p class="large">
        Please enter the email address you provided when saving the form:
      </p>
      <p *ngIf="emailError" class="error">
        The email address doesn’t match the one you provided when saving the
        form.
      </p>
      <label for="emailAddressSaved">Email</label>
      <input
        id="emailAddressSaved"
        type="email"
        [(ngModel)]="emailAddress"
        pInputText
        style="margin-bottom: 10px"
        maxlength="80"
        email
      />
    </div>
  </div>

  <p-footer>
    <button
      type="button"
      [disabled]="!isValidateEmail()"
      pButton
      label="Continue"
      (click)="loadSavedFormByEmail()"
      class="p-button-rounded p-button-secondary"
    ></button>
    <button
      type="button"
      pButton
      (click)="savedFormEmailModal = false"
      label="Cancel"
      class="p-button-rounded p-button-outlined p-button-secondary"
    ></button>
  </p-footer>
</p-dialog>
<!--------------------------- End saveFormEmailModal ------------------------->

<!--------------------------- Save for Submit ------------------------->
<p-dialog
  header="Save for Submit"
  [(visible)]="saveForSubmitModal"
  [modal]="true"
  [responsive]="true"
  [style]="{ width: '600px', minWidth: '300px' }"
  [maximizable]="false"
  [resizable]="true"
>
  <div class="p-grid p-fluid">
    <div class="p-col">
      <p class="large">
        Please provide an email address where you can receive copy of form
        submission.
      </p>

      <label for="emailAddressCopy">Email</label>
      <input
        id="emailAddressCopy"
        type="email"
        [(ngModel)]="emailCopyToSubmitter"
        pInputText
        style="margin-bottom: 10px"
        maxlength="80"
        email
      />
    </div>
  </div>

  <p-footer>
    <button
      type="button"
      [disabled]="!isValidateSubmitEmail()"
      pButton
      label="OK"
      (click)="sendSubmitEmail()"
      class="p-button-rounded p-button-secondary"
    ></button>
    <button
      type="button"
      pButton
      (click)="saveForSubmitModal = false"
      label="Cancel"
      class="p-button-rounded p-button-outlined p-button-secondary"
    ></button>
  </p-footer>
</p-dialog>
<!--------------------------- End Save for Later ------------------------->
